class PackageOrder {
  static DEFAULTS = {
    MIN_QUANTITY: 10,
    MAX_QUANTITY: 9999,
  };

  constructor(element) {
    this.element = element;
    this.quantityInput = element.querySelector('.quantity-picker__input');
    this.minusBtn = element.querySelector('.quantity-picker__btn--minus');
    this.plusBtn = element.querySelector('.quantity-picker__btn--plus');
    this.discountInfo = element.querySelector('.quantity-discount-info');
    this.orderBtn = element.querySelector('[data-action="direct-order"]');

    this.basePriceEx = parseFloat(element.dataset.basePriceEx) || 0;
    this.basePriceIncl = parseFloat(element.dataset.basePriceIncl) || 0;
    this.packageId = element.dataset.packageId;
    this.sizeParam = element.dataset.sizeParam || '';

    try {
      const discountScript = document.getElementById(
        'package-volume-discounts',
      );
      this.volumeDiscounts = discountScript
        ? JSON.parse(discountScript.textContent)
        : [];
    } catch {
      this.volumeDiscounts = [];
    }

    this.init();
  }

  init() {
    if (!this.quantityInput) return;

    this.minusBtn?.addEventListener('click', () => this.changeQuantity(-1));
    this.plusBtn?.addEventListener('click', () => this.changeQuantity(1));
    this.quantityInput.addEventListener('blur', () => this.handleBlur());
    this.quantityInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') this.quantityInput.blur();
    });

    this.updatePrice();
  }

  changeQuantity(delta) {
    const currentValue =
      parseInt(this.quantityInput.value) || PackageOrder.DEFAULTS.MIN_QUANTITY;
    const min =
      parseInt(this.quantityInput.min) || PackageOrder.DEFAULTS.MIN_QUANTITY;
    const max =
      parseInt(this.quantityInput.max) || PackageOrder.DEFAULTS.MAX_QUANTITY;
    const newValue = Math.max(min, Math.min(max, currentValue + delta));

    if (newValue !== currentValue) {
      this.quantityInput.value = newValue;
      this.updatePrice();
    }
  }

  handleBlur() {
    this.validateInput();
    this.updatePrice();
  }

  validateInput() {
    const value =
      parseInt(this.quantityInput.value) || PackageOrder.DEFAULTS.MIN_QUANTITY;
    const min =
      parseInt(this.quantityInput.min) || PackageOrder.DEFAULTS.MIN_QUANTITY;
    const max =
      parseInt(this.quantityInput.max) || PackageOrder.DEFAULTS.MAX_QUANTITY;

    this.quantityInput.value = Math.max(min, Math.min(max, value));
  }

  getApplicableDiscount(quantity) {
    if (!this.volumeDiscounts?.length) {
      return { percentage: 0, range: null };
    }

    const sortedDiscounts = [...this.volumeDiscounts].sort(
      (a, b) => (b.quantity_min || 0) - (a.quantity_min || 0),
    );

    for (const discount of sortedDiscounts) {
      const min = parseInt(discount.quantity_min) || 0;
      const max = discount.quantity_max
        ? parseInt(discount.quantity_max)
        : null;
      const percentage = parseFloat(discount.percentage) || 0;

      if (quantity >= min && (max === null || quantity <= max)) {
        const range =
          max === null || max >= 100000 ? `${min}+` : `${min} - ${max}`;
        return { percentage, range };
      }
    }

    return { percentage: 0, range: null };
  }

  updatePrice() {
    const quantity =
      parseInt(this.quantityInput.value) || PackageOrder.DEFAULTS.MIN_QUANTITY;
    const discount = this.getApplicableDiscount(quantity);

    this.updateDiscountInfo(quantity, discount);
    this.updateButtonState(quantity);
  }

  updateDiscountInfo(quantity, discount) {
    if (!this.discountInfo) return;

    const parts = [];

    if (discount.percentage > 0) {
      parts.push(
        `<div class="d-flex align-items-center text-secondary fs-sm fw-medium mb-1">
          <i class="icon-checkmark me-1"></i>
          Je krijgt nu ${discount.percentage}% korting
        </div>`,
      );
    }

    const nextDiscount = this.getNextDiscountTier(quantity);
    if (nextDiscount) {
      const remaining = nextDiscount.min - quantity;
      const plural = remaining !== 1 ? 'ten' : '';
      parts.push(
        `<div class="d-flex align-items-center text-gray-600 fs-sm">
          <i class="icon-alert me-1"></i>
          Nog ${remaining} pakket${plural} voor ${nextDiscount.percentage}% korting
        </div>`,
      );
    }

    this.discountInfo.innerHTML = parts.join('');
  }

  getNextDiscountTier(currentQuantity) {
    if (!this.volumeDiscounts?.length) return null;

    const nextTier = this.volumeDiscounts
      .filter((d) => (d.quantity_min || 0) > currentQuantity)
      .sort((a, b) => (a.quantity_min || 0) - (b.quantity_min || 0))[0];

    return nextTier
      ? {
          min: parseInt(nextTier.quantity_min) || 0,
          percentage: parseFloat(nextTier.percentage) || 0,
        }
      : null;
  }

  updateButtonState(quantity) {
    if (!this.orderBtn) return;

    this.orderBtn.classList.toggle(
      'disabled',
      quantity < PackageOrder.DEFAULTS.MIN_QUANTITY,
    );

    this.orderBtn.href = `${window.location.origin}/pakket-kiezen/?stap=personaliseren&pakket=${this.packageId}${this.sizeParam}&aantal=${quantity}`;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.package-order-section')
    .forEach((section) => new PackageOrder(section));
});
